import {
  AppointmentBookToStatusMappingHandler,
  IBaseAppointmentBook,
} from '../../../mappings/appointment-book-to-status';
import {
  IOasisAppointmentBook,
  OasisAppointmentBook,
  PatientAppointmentBookSourceEntity,
} from '../../source/entities/appointment-book';

export class OasisAppointmentBookToStatusMappingHandler extends AppointmentBookToStatusMappingHandler<
  OasisAppointmentBook,
  PatientAppointmentBookSourceEntity
> {
  sourceEntity = new PatientAppointmentBookSourceEntity();

  translateFn(record: IOasisAppointmentBook): IBaseAppointmentBook {
    return record;
  }
}
